import React, { useState } from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import TextField from '../components/TextField';
import { Row } from "../components/Flex";
import { PrimaryButton, SecondaryButton } from "../components/buttons/Buttons";

interface Props {
    open: boolean;
    onClose: () => void;
    onAdd: (email: string) => void;
}

function CreateUserDialog({ open, onAdd, onClose }: Props) {
    const [email, setEmail] = useState('');

    const onConfirm = () => onAdd(email);
    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Create new user
                    </DialogTitle>
                    <TextField label="Email" value={email} setValue={setEmail} />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Create" onClick={onConfirm} disabled={!email} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default CreateUserDialog;
